import { Uuid, uuidSerializer } from "@legacy-megarax/common";
import { SortFilter, sortFilterSerializer } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

import { CustomerStatus, customerStatusSerializer } from "../customer/customerStatus";
import { VisitAddress, visitAddressSerialziers } from "./visitAddress";

export type CustomerSimple = {
  uuid: Uuid;
  name: string | null;
  regionName: string | null;
  visitAddress: VisitAddress | null;
  hasPricingRules: boolean;
  lastOrderTime: Date | null;
  lastVisitTime: Date | null;
  tags: string[];
  permanentTradeRoutesCount: number | null;
  status: CustomerStatus | null;
};

export const customerSimpleSerializer = MSerializers.object<CustomerSimple>({
  uuid: uuidSerializer,
  regionName: MSerializers.string.nullable(),
  name: MSerializers.string.nullable(),
  hasPricingRules: MSerializers.boolean,
  visitAddress: visitAddressSerialziers.nullable(),
  lastOrderTime: MSerializers.datetime.nullable(),
  lastVisitTime: MSerializers.datetime.nullable(),
  tags: MSerializers.array(MSerializers.string),
  status: customerStatusSerializer.nullable(),
  permanentTradeRoutesCount: MSerializers.integer.nullable(),
});

export const customerSortFields = ["name", "regionName", "locality", "lastOrderTime", "lastVisitTime"] as const;
export type CustomerSortField = (typeof customerSortFields)[number];

export type CustomerListQueryFilters = {
  limit?: number;
  offset?: number;
  searchText?: string;
  status?: CustomerStatus[];
  regionName?: string[];
  hasPricingRules?: boolean;
  sortBy?: SortFilter<CustomerSortField>[];
  tags?: string[];
  orderedIn?: number;
  visitedIn?: number;
  isOnRoute?: boolean;
};

export const customerListQueryFiltersSerializer = MSerializers.object<CustomerListQueryFilters>({
  limit: MSerializers.integer.optional(),
  offset: MSerializers.integer.optional(),
  searchText: MSerializers.string.optional(),
  status: MSerializers.array(customerStatusSerializer).optional(),
  hasPricingRules: MSerializers.booleanString.optional(),
  regionName: MSerializers.array(MSerializers.string).optional(),
  sortBy: sortFilterSerializer(...customerSortFields).optional(),
  tags: MSerializers.array(MSerializers.string).optional(),
  orderedIn: MSerializers.integer.optional(),
  visitedIn: MSerializers.integer.optional(),
  isOnRoute: MSerializers.booleanString.optional(),
});

export type MyRegionCustomerListQueryFilters = {
  limit?: number;
  offset?: number;
  searchText?: string;
};

export const listByMyRegionQueryFiltersSerializer = MSerializers.object<MyRegionCustomerListQueryFilters>({
  limit: MSerializers.integer.optional(),
  offset: MSerializers.integer.optional(),
  searchText: MSerializers.string.optional(),
});
